import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';
import headerSlicer from '../components/header/headerSlicer';
import { grupoApiSlice } from '../features/grupo/grupoApiSlice';
import processoSelecionadoSlice from '../features/iniciarProcesso/processoSelecionadoSlice';
import publicacaoSlice from '../features/site/features/noticia/publicacaoSlice';
import noticiaPublicListFiltroSlice from '../features/site/features/noticia/listPublic/noticiaPublicListFiltroSlice';
import publicacaoOficialPublicListFiltroSlice from '../features/site/features/publicacaoOficial/listPublic/publicacaoOficialPublicListFiltroSlice';
import licitacaoPublicListFiltroSlice from '../features/site/features/licitacao/listPublic/licitacaoPublicListFiltroSlice';
import menuPrincipalSiteSlice from '../features/site/features/menus/menuPrincipalSite/menuPrincipalSiteSlice';
import themeSelecionadoSlice from '../config/themeSelecionadoSlice';

export const store = configureStore({
  reducer: {
    header: headerSlicer,
    processoSelecionado: processoSelecionadoSlice,
    publicacao: publicacaoSlice,
    noticiaPublicListFiltro: noticiaPublicListFiltroSlice,
    licitacaoPublicListFiltro: licitacaoPublicListFiltroSlice,
    publicacaoOficialPublicListFiltro: publicacaoOficialPublicListFiltroSlice,
    menuPrincipalSite: menuPrincipalSiteSlice,
    themeSelecionado: themeSelecionadoSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
    grupoApiSlice: grupoApiSlice.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
